import { Component, input, inject, computed } from '@angular/core';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';

import { HeroButtonGroupComponent } from '../hero-button-group/hero-button-group.component';
import { showButtonGroup } from '../utils/hero.utils';
import type { Hero } from '../models/hero.model';

@Component({
  selector: 'wl-hero-heading',
  standalone: true,
  imports: [HeroButtonGroupComponent, JssModule],
  templateUrl: './hero-heading.component.html',
  styleUrls: [
    './hero-heading.component.essent.scss',
    './hero-heading.component.ed.scss',
  ],
})
export class HeroHeadingComponent {
  readonly hero = input.required<Partial<Hero>>();
  readonly hasEssentRebranding = input<boolean>(false);

  private readonly brand = inject(ENVIRONMENT_CONFIG).brand;

  private readonly isEd = computed(() => this.brand === 'ed');

  readonly headingLine1 = computed(() => this.hero().headingLine1);
  readonly headingLine2 = computed(() => this.hero().headingLine2);

  readonly showButtonGroup = computed(
    () => this.isEd() && showButtonGroup(this.hero())
  );
}
